import React, {
    Component,
} from 'react';
import ReactHighcharts from '../../../../CommonComponents/Highcharts';
import {
    computeChartStringKey,
} from './ProgressChartHelpers';
import OwnerDropdown from '../../OwnerDropdown/OwnerDropdownContainer';
import SplitTabs from '../../SplitTabs/SplitTabsContainer';
import NeedsAnalysis from '../NeedsAnalysis/NeedsAnalysisContainer';
import IncomeReplacement from '../IncomeReplacement/IncomeReplacementContainer';
import {
    NEEDS_ANALYSIS,
    INCOME_REPLACEMENT,
} from './ProgressChartConstants';

export default class ProgressChartView extends Component {
    render() {
        const {
            isPrint,
            clientId,
            fpId,
            goalId,
            tabIndex,
            tabId,
            ownerIndex,
            breakdown,
            note,
            subgoalId,
            setSelectedOwnerIndex,
            chartData,
            hasChartData,
            principalName,
            spouseName,
            setSelectedTabIndex,
            tabs,
        } = this.props;

        let breakdownComponent = null;

        switch (tabId) {
            case NEEDS_ANALYSIS:
                breakdownComponent = <NeedsAnalysis
                    isPrint={isPrint}
                    clientId={clientId}
                    goalId={goalId}
                    subgoalId={subgoalId}
                    breakdown={breakdown}
                    note={note.Notes.find((note) => note.Name === NEEDS_ANALYSIS)}
                />;
                break;
            case INCOME_REPLACEMENT:
                breakdownComponent = <IncomeReplacement
                    isPrint={isPrint}
                    clientId={clientId}
                    goalId={goalId}
                    subgoalId={subgoalId}
                    breakdown={breakdown}
                    note={note.Notes.find((note) => note.Name === INCOME_REPLACEMENT)}
                />;
                break;
        }

        return <div className="progress-chart-container NewFinancialPlan_LifeInsuranceProgressChart">
            <SplitTabs
                isPrint={isPrint}
                clientId={clientId}
                goalId={goalId}
                subgoalId={subgoalId}
                tabs={tabs}
                setSelectedIndex={setSelectedTabIndex}
                leftChildren={
                    <div>
                        <div className="chart-header">
                            {!isPrint && <OwnerDropdown
                                clientId={clientId}
                                goalId={goalId}
                                principalName={principalName}
                                spouseName={spouseName}
                                setSelectedIndex={setSelectedOwnerIndex}
                            />}
                            <ul className="legend">
                                <li><i />Current</li>
                                <li><i className="stripe2" style={{ background: "#e5f8ff" }}/>Recommended</li>
                            </ul>
                        </div>
                        {hasChartData && <ReactHighcharts
                            autoResize={true}
                            className="progress-chart"
                            container={computeChartStringKey(
                                ownerIndex.toString(),
                                `${subgoalId}-${tabIndex}`,
                                fpId,
                                clientId
                            )}
                            options={chartData}
                        />}
                    </div>
                }
                rightChildren={breakdownComponent}
            />
        </div>;
    }
};
